import { deepCopy } from "../../utils";
import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { showDangerToast } from "../../validation/ToastContainer";
import { ACTION_GROUPS_LOADED } from "./AddDeviceModalReducer";
import { securedFetch } from "../../auth/authService";
import { GROUP_API } from "../../vars";
import { filterGroupsForCurrentUser } from "../../auth/groupAccess";

export function list() {
    return securedFetch(GROUP_API)
        .then(response => response.json())
        .then(data => {
            data = filterGroupsForCurrentUser(deepCopy(data), store.getState().auth);
            store.dispatch(createAction(ACTION_GROUPS_LOADED)({ groups: data }));
            return data;
        }).catch(err => {
            showDangerToast(err.message, "Error");
        })
}
